import React from "react";

import { Link, useLocation } from "react-router-dom";
import ButtonWhatsapp from "../components/ButtonWhatsapp";
import Footer from "../components/Footer";

export default function ContactUs() {
  const { pathname } = useLocation();

  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [responseMessage, setResponseMessage] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://tigress-production.up.railway.app/api/contact",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setResponseMessage("Message sent successfully!");
        setErrorMessage("");
      } else {
        setErrorMessage(data.error || "Something went wrong.");
        setResponseMessage("");
      }
    } catch (error) {
      setErrorMessage("Failed to send the message. Please try again.");
      setResponseMessage("");
    }
  };

  return (
    <div>
         <div className="container-fluid topbar bg-secondary d-none d-xl-block w-100">
        <div className="container">
          <div
            className="row gx-0 align-items-center"
            style={{ height: "45px" }}
          >
            <div className="col-lg-6 text-center text-lg-start mb-lg-0">
              <div className="d-flex flex-wrap">
                <a  href="https://www.google.com/maps?q=Batalla+de+Puebla,+1ro+de+Mayo,+23406+San+José+del+Cabo,+B.C.S.,+México" className="text-muted me-4"
                
                  target="_blank"
                        rel="noopener noreferrer"
                >
                  <i className="fas fa-map-marker-alt text-primary me-2"></i>
                  Our location
                </a>
                <a href="tel:+5216242302304" className="text-muted me-4"
                     target="_blank" 
                   rel="noopener noreferrer"
                >
                  <i className="fas fa-phone-alt text-primary me-2"></i>
                  +5216242302304
                </a>
                <a href="mailto:reservations@tigresstransport.com.mx" className="text-muted me-0"
                     target="_blank" 
                   rel="noopener noreferrer"
                >
                  <i className="fas fa-envelope text-primary me-2"></i>
                  reservations@tigresstransport.com.mx
                </a>
              </div>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <div className="d-flex align-items-center justify-content-end">
                <a
                  href="https://www.facebook.com/profile.php?id=100091411777035"
                  className="btn btn-light btn-sm-square rounded-circle me-3"
                   target="_blank" 
                   rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
{/*                 <a
                  href="#"
                  className="btn btn-light btn-sm-square rounded-circle me-3"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a
                  href="#"
                  className="btn btn-light btn-sm-square rounded-circle me-3"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="#"
                  className="btn btn-light btn-sm-square rounded-circle me-0"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid nav-bar sticky-top px-0 px-lg-4 py-2 py-lg-0">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <Link to="/" className="navbar-brand p-0">
              <img src="img/Logo.jpg" alt="Logo" />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
            >
              <span className="fa fa-bars"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarCollapse">
              <div className="navbar-nav mx-auto py-0">
                <Link to="/" className="nav-item nav-link  ">
                  Home
                </Link>
                <div className="nav-item dropdown">
                  <Link
                    href="#"
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    About us
                  </Link>
                  <div className="dropdown-menu m-0">
                    <Link to="/about-us" className="dropdown-item">
                      About us
                    </Link>

                    <Link
                      to="/private-transportation"
                      className="dropdown-item"
                    >
                      Private Transportation
                    </Link>
                    {/*    <Link to="/shared-shuttle" className="dropdown-item">
                            Shared Shutttle
                          </Link> */}
                    <Link to="/large-groups" className="dropdown-item ">
                      Large Groups
                    </Link>

                    <Link to="/gallery" className="dropdown-item">
                      Gallery
                    </Link>
                  </div>
                </div>
                <Link to="/destinations" className="nav-item nav-link ">
                  Destinations
                </Link>
                <Link to="/vehicles" className="nav-item nav-link">
                  Our Fleet
                </Link>
                <Link to="/reviews" className="nav-item nav-link">
                  Our Reviews
                </Link>
                <Link to="/contact-us" className="nav-item nav-link active">
                  Contact Us
                </Link>
              </div>
              <Link
                to="/book-now"
                className="btn btn-primary rounded-pill py-2 px-4"
              >
                Book Now
              </Link>
            </div>
          </nav>
        </div>
      </div>
      <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "900px" }}>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Contact Us
          </h4>
        </div>
      </div>

      <div class="container-fluid contact py-5">
        <div class="container py-5">
          <div
            class="text-center mx-auto pb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "800px" }}
          >
            <h1 class="display-5 text-capitalize text-primary mb-3">
              Contact Us
            </h1>
            <p class="mb-0">
              Customer service is open from 24/7, Monday through Sunday. We are
              always looking for ways to improve our service and appreciate
              customer suggestions and feedback. We will be glad to answer all
              your questions 🥰.
            </p>
          </div>
          <div class="row g-5">
            <div class="col-12 wow fadeInUp" data-wow-delay="0.1s">
              <div class="row g-5">
                <div class="col-md-6 col-lg-6 col-xl-3">
                  <div class="contact-add-item p-4">
                    <div class="contact-icon mb-4">
                      <i class="fas fa-map-marker-alt fa-2x"></i>
                    </div>
                    <div>
                      <h4>Address</h4>
                      <a
                        href="https://www.google.com/maps?q=Batalla+de+Puebla,+1ro+de+Mayo,+23406+San+José+del+Cabo,+B.C.S.,+México"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="mb-0 text-decoration-none "
                      >
                        Batalla de Puebla, 1ro de Mayo, 23406 San José del Cabo,
                        B.C.S., México
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                  data-wow-delay="0.3s"
                >
                  <div class="contact-add-item p-4">
                    <div class="contact-icon mb-4">
                      <i class="fas fa-envelope fa-2x"></i>
                    </div>
                    <div>
                      <h4>Mail Us</h4>

                      <a
                        href="https://www.google.com/maps?q=Batalla+de+Puebla,+1ro+de+Mayo,+23406+San+José+del+Cabo,+B.C.S.,+México"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="mb-0 text-decoration-none "
                      >
                        reservations@tigresstransport.com.mx
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                  data-wow-delay="0.5s"
                >
                  <div class="contact-add-item p-4">
                    <div class="contact-icon mb-4">
                      <i class="fa fa-phone-alt fa-2x"></i>
                    </div>
                    <div>
                      <h4>Telephone</h4>
                      <a
                        href="tel:+5216242302304"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        ( +52 ) 1 624 230 2304{" "}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                  data-wow-delay="0.7s"
                >
                  <div class="contact-add-item p-4">
                    <div class="contact-icon mb-4">
                      <i class="fab fa-firefox-browser fa-2x"></i>
                    </div>
                    <div>
                      <h4>Contact the developer</h4>

                      <a
                        href="https://www.elaritech.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        elaritech.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-6 wow fadeInUp" data-wow-delay="0.1s">
              <div class="bg-secondary p-5 rounded">
                <h4 class="text-primary mb-4">Send Your Message</h4>
                <form onSubmit={handleSubmit}>
                  <div className="row g-4">
                    <div className="col-lg-12 col-xl-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Full Name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="name">Full Name</label>
                      </div>
                    </div>
                    <div className="col-lg-12 col-xl-6">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Your Email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="email">Your Email</label>
                      </div>
                    </div>
                    <div className="col-lg-12 col-xl-12">
                      <div className="form-floating">
                        <input
                          type="phone"
                          className="form-control"
                          id="phone"
                          placeholder="Phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="phone">Your Phone</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="subject"
                          placeholder="Subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="subject">Subject</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          placeholder="Leave a message here"
                          id="message"
                          style={{ height: "160px" }}
                          name="message"
                          value={formData.message}
                          onChange={handleInputChange}
                        ></textarea>
                        <label htmlFor="message">Message</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-light w-100 py-3"
                      >
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              {responseMessage && (
                <div className="alert alert-success mt-3" role="alert">
                  {responseMessage}
                </div>
              )}
              {errorMessage && (
                <div className="alert alert-danger mt-3" role="alert">
                  {errorMessage}
                </div>
              )}
            </div>
            <div class="col-12 col-xl-1 wow fadeInUp" data-wow-delay="0.3s">
              <div class="d-flex flex-xl-column align-items-center justify-content-center">
                <a
                  class="btn btn-xl-square btn-light rounded-circle mb-0 mb-xl-4 me-4 me-xl-0"
                  href=""
                >
                  <i class="fab fa-facebook-f"></i>
                </a>
              {/*   <a
                  class="btn btn-xl-square btn-light rounded-circle mb-0 mb-xl-4 me-4 me-xl-0"
                  href=""
                >
                  <i class="fab fa-twitter"></i>
                </a>
                <a
                  class="btn btn-xl-square btn-light rounded-circle mb-0 mb-xl-4 me-4 me-xl-0"
                  href=""
                >
                  <i class="fab fa-instagram"></i>
                </a>
                <a
                  class="btn btn-xl-square btn-light rounded-circle mb-0 mb-xl-0 me-0 me-xl-0"
                  href=""
                >
                  <i class="fab fa-linkedin-in"></i>
                </a> */}
              </div>
            </div>
            <div class="col-12 col-xl-5 wow fadeInUp" data-wow-delay="0.1s">
              <div class="p-5 bg-light rounded">
                <div class="bg-white rounded p-4 mb-4">
                  <div class="d-flex align-items-center flex-shrink-0 mb-3">
                    <div>
                      <p class="mb-0 text-dark me-2">Address:</p>
                      <i class="fas fa-map-marker-alt text-primary me-2"></i>
                      <a
                        href="https://www.google.com/maps?q=Batalla+de+Puebla,+1ro+de+Mayo,+23406+San+José+del+Cabo,+B.C.S.,+México"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="mb-0 text-decoration-none "
                      >
                        Batalla de Puebla, 1ro de Mayo, 23406 San José del Cabo,
                        B.C.S., México
                      </a>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <p class="mb-0 text-dark me-2">Telephone:</p>
                    <i class="fa fa-phone-alt text-primary me-2"></i>
                    <p class="mb-0">
                      {" "}
                      <a
                        href="tel:+5216242302304"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        ( +52 ) 1 624 230 2304{" "}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="rounded">
                <iframe
                  className="rounded w-100"
                  style={{ height: "400px" }}
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.1191670627563!2d-109.70355002399131!3d23.056092315075137!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86af5084be973d1b%3A0x76fbcedcc386c7a8!2sBatalla%20de%20Puebla%2C%201ro%20de%20Mayo%2C%2023406%20San%20Jos%C3%A9%20del%20Cabo%2C%20B.C.S.%2C%20M%C3%A9xico!5e0!3m2!1sen!2sus!4v1737651202078!5m2!1sen!2sus"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <ButtonWhatsapp />
    </div>
  );
}
